import React, { useState } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import axios from "../../context/AxiosInstance";
import Swal from "sweetalert2";

const ConfirmDeleteModal = ({ show, handleClose, selectedItem, token, refreshData }) => {
  const [loading, setLoading] = useState(false);

  const handleConfirmDelete = async () => {
    if (!selectedItem || !selectedItem.id_user) {
      Swal.fire("Erreur", "Aucun utilisateur sélectionné", "error");
      return;
    }

    setLoading(true);
    try {
      await axios.delete(`/utilisateurs/${selectedItem.id_user}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      Swal.fire("Supprimé ✅", "L'utilisateur a été déplacé vers la corbeille.", "success");
      refreshData();
      handleClose();
    } catch (err) {
      Swal.fire("Erreur ❌", err.response?.data?.detail?.message || "Échec de la suppression", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Confirmation</Modal.Title>
      </Modal.Header>
      <Modal.Body>Voulez-vous supprimer cet utilisateur ? Il sera déplacé vers la corbeille et pourra être restauré.</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={loading}>Annuler</Button>
        <Button variant="danger" onClick={handleConfirmDelete} disabled={loading}>
          {loading ? <Spinner animation="border" size="sm" /> : "Supprimer"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmDeleteModal;
